// extracted by mini-css-extract-plugin
module.exports = {"policyTemplates":"policyTemplates___2KmdS","policyTemplate":"policyTemplate___X3HMh"};